import { render, staticRenderFns } from "./GoodsUpdate.vue?vue&type=template&id=267d8b14"
import script from "./GoodsUpdate.vue?vue&type=script&lang=js"
export * from "./GoodsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports